export const PlaceholderContainerFooter = () => (
  <div className="mt-2 text-xs text-gray-500">
    Messages here are test values for previewing this placeholder — they aren't part of the prompt
    template.{" "}
    <a
      href="https://docs.promptlayer.com/features/prompt-registry/placeholder-messages"
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-600 hover:text-blue-800"
    >
      Learn more
    </a>
  </div>
);
